var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Watch } from "vue-property-decorator";
import TheHeader from "@/components/TheHeader/TheHeader.vue";
import Player from "@/components/ThePlayer/ThePlayer.vue";
import TheLeftSidebar from "@/components/TheLeftSidebar/TheLeftSidebar.vue";
import TheRightSidebar from "@/components/TheRightSidebar/TheRightSidebar.vue";
import snackbarBus from "@/snackbarBus";
import HTTP from "@/http";
var App = (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.snackbar = {
            show: false,
            text: "",
        };
        _this.dark = false;
        _this.isAuthenticating = true;
        return _this;
    }
    Object.defineProperty(App.prototype, "fluid", {
        get: function () {
            return ["xs", "sm", "md"].includes(this.$vuetify.breakpoint.name);
        },
        enumerable: true,
        configurable: true
    });
    App.prototype.setDark = function (val) {
        this.dark = val;
    };
    App.prototype.created = function () {
        var _this = this;
        this.dark = "dark" === localStorage.getItem('theme');
        this["$auth"].getUserInfo().then(function () {
            _this["$auth"].user.token = _this["$auth"].getToken();
            _this.$store.commit('SET_USER', _this["$auth"].user);
            _this.$store.commit('SET_IS_AUTHENTICATED', !!_this.$store.state.user.user);
            _this.isAuthenticating = false;
        }).catch(function () {
            _this.isAuthenticating = false;
        });
        snackbarBus.$on("show", function (text) {
            _this.snackbar.show = false;
            _this.$nextTick(function () {
                _this.snackbar.show = true;
                _this.snackbar.text = text;
            });
        });
        HTTP.get("users/me")
            .then(function (response) {
        })
            .catch(function (response) {
        });
        snackbarBus.$on("success", function (text) {
            _this.snackbar.show = true;
            _this.snackbar.text = text;
        });
    };
    App.prototype.onRouteChanged = function () {
        document.title = "App";
    };
    __decorate([
        Watch("$route"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], App.prototype, "onRouteChanged", null);
    App = __decorate([
        Component({
            components: {
                "the-header": TheHeader,
                "the-left-sidebar": TheLeftSidebar,
                "the-right-sidebar": TheRightSidebar,
                "the-player": Player,
            },
        })
    ], App);
    return App;
}(Vue));
export default App;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
// module id = 207
// module chunks = 0